// Utility to fix mojibake/corrupted special characters for Finnish/Swedish
const mojibakeMap: Record<string, string> = {
  '\u0000e4': 'ä', 'e4': 'ä',
  '\u0000c4': 'Ä', 'c4': 'Ä',
  '\u0000f6': 'ö', 'f6': 'ö',
  '\u0000d6': 'Ö', 'd6': 'Ö',
  '\u0000e5': 'å', 'e5': 'å',
  '\u0000c5': 'Å', 'c5': 'Å',
};

export function fixMojibake(str: string): string {
  // Replace null-byte-prefixed hex
  let fixed = str.replace(/(\u0000[a-fA-F0-9]{2})/g, (match) => mojibakeMap[match] || match);
  // Replace plain hex (only as a standalone token). Never directly after "%": that is a
  // percent-encoded URL escape, not mojibake, and "%" counts as a word boundary, so without the
  // lookbehind "%e4"/"%e5" in a UTF-8 URL path became "%ä"/"%å" and broke stored apply links
  // (confirmed in prod on Durlston Partners, via the lastSeen touch that runs this on every field).
  fixed = fixed.replace(/(?<!%)\b([a-fA-F0-9]{2})\b/g, (match) => mojibakeMap[match] || match);
  return fixed;
} 